export default __webpack_public_path__ + "static/media/clip-1448.ed10ac71.png";